function formatTime( ms ) {

	if ( ms === null || ms === undefined || ! Number.isFinite( ms ) ) return '—';

	const t = ms / 1000;
	const m = Math.floor( t / 60 );
	const s = t - m * 60;
	return `${ m }:${ s.toFixed( 2 ).padStart( 5, '0' ) }`;

}

export default class Leaderboard {

	constructor() {

		this.players = new Map();
		this.selfId = null;
		this._dirty = true;
		this._joinCounter = 0;

		const style = document.createElement( 'style' );
		style.textContent = `
			#leaderboard {
				position: absolute;
				top: 56px;
				right: 12px;
				width: 220px;
				color: #fff;
				font: 600 12px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
				background: rgba(0,0,0,0.5);
				padding: 10px 12px;
				border-radius: 10px;
				line-height: 1.4;
				text-shadow: 0 1px 2px rgba(0,0,0,0.6);
				user-select: none;
				pointer-events: none;
				z-index: 10;
				backdrop-filter: blur(8px);
				-webkit-backdrop-filter: blur(8px);
			}
			#leaderboard .header {
				font-size: 10px;
				letter-spacing: 0.12em;
				opacity: 0.6;
				font-weight: 700;
				margin-bottom: 6px;
			}
			#leaderboard .row {
				display: grid;
				grid-template-columns: 18px 1fr auto;
				gap: 6px;
				align-items: baseline;
				padding: 3px 6px;
				border-radius: 4px;
				font-variant-numeric: tabular-nums;
			}
			#leaderboard .row .pos { opacity: 0.55; font-weight: 500; }
			#leaderboard .row .name {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			#leaderboard .row .best { font-size: 11px; opacity: 0.95; }
			#leaderboard .row .lap { font-size: 10px; opacity: 0.55; margin-top: 1px; }
			#leaderboard .row.self { border-left: 2px solid #5af168; padding-left: 4px; }
			#leaderboard .row .meta {
				grid-column: 2 / 4;
				display: flex;
				justify-content: space-between;
				font-size: 10px;
				opacity: 0.55;
			}
		`;
		document.head.appendChild( style );
		this._style = style;

		const el = document.createElement( 'div' );
		el.id = 'leaderboard';
		el.innerHTML = '<div class="header"><span class="title">LEADERBOARD</span> · <span class="room"></span></div><div class="rows"></div>';
		document.body.appendChild( el );

		this._el = el;
		this._rowsEl = el.querySelector( '.rows' );
		this._roomEl = el.querySelector( '.room' );
		this._roomEl.textContent = 'solo';

	}

	setRoom( label ) {

		if ( this._roomEl ) this._roomEl.textContent = label;

	}

	setSelf( { id, name } ) {

		this.selfId = id;
		this.addPlayer( { id, name } );

	}

	addPlayer( { id, name } ) {

		if ( ! this.players.has( id ) ) {

			this.players.set( id, {
				id,
				name: name || 'Player',
				bestLap: null,
				currentLap: 1,
				joinOrder: this._joinCounter ++,
			} );
			this._dirty = true;

		} else {

			const p = this.players.get( id );
			if ( name && p.name !== name ) {

				p.name = name;
				this._dirty = true;

			}

		}

	}

	removePlayer( id ) {

		if ( this.players.delete( id ) ) this._dirty = true;

	}

	setBestLap( id, ms ) {

		const p = this.players.get( id );
		if ( ! p ) return;
		if ( p.bestLap === ms ) return;
		p.bestLap = ms;
		this._dirty = true;

	}

	setCurrentLap( id, lapNumber ) {

		const p = this.players.get( id );
		if ( ! p ) return;
		if ( p.currentLap === lapNumber ) return;
		p.currentLap = lapNumber;
		this._dirty = true;

	}

	update() {

		if ( ! this._dirty ) return;
		this._dirty = false;
		this._render();

	}

	_render() {

		const list = Array.from( this.players.values() );
		list.sort( ( a, b ) => {

			const aHas = a.bestLap !== null && a.bestLap !== undefined;
			const bHas = b.bestLap !== null && b.bestLap !== undefined;
			if ( aHas && bHas ) return a.bestLap - b.bestLap;
			if ( aHas ) return -1;
			if ( bHas ) return 1;
			return a.joinOrder - b.joinOrder;

		} );

		const html = list.map( ( p, i ) => {

			const isSelf = p.id === this.selfId;
			const cls = isSelf ? 'row self' : 'row';
			const name = escapeHtml( p.name );
			const best = formatTime( p.bestLap );
			const lap = `L${ p.currentLap }`;
			return `<div class="${ cls }"><span class="pos">${ i + 1 }.</span><span class="name">${ name }</span><span class="best">${ best }</span><span class="meta"><span></span><span class="lap">${ lap }</span></span></div>`;

		} ).join( '' );

		this._rowsEl.innerHTML = html;

	}

	dispose() {

		if ( this._el && this._el.parentNode ) this._el.parentNode.removeChild( this._el );
		if ( this._style && this._style.parentNode ) this._style.parentNode.removeChild( this._style );
		this._el = null;
		this._style = null;
		this._rowsEl = null;
		this.players.clear();

	}

}

function escapeHtml( s ) {

	return String( s )
		.replace( /&/g, '&amp;' )
		.replace( /</g, '&lt;' )
		.replace( />/g, '&gt;' )
		.replace( /"/g, '&quot;' )
		.replace( /'/g, '&#39;' );

}
